import { Loader2 } from 'lucide-react';
import { cn } from '../../lib/utils';

const sizeClasses = {
  xs: 'h-3 w-3',
  sm: 'h-3.5 w-3.5',
  md: 'h-5 w-5',
} as const;

type SpinnerSize = keyof typeof sizeClasses;

interface SpinnerProps {
  size?: SpinnerSize;
  className?: string;
}

/**
 * Standardized animated spinner wrapping Loader2.
 * Use instead of inline `<Loader2 className="h-N w-N animate-spin" />`.
 *
 * - `xs` (12px) — inline/compact indicators
 * - `sm` (14px) — buttons, badges, step icons
 * - `md` (20px) — section-level loading, LoadingState
 */
export function Spinner({ size = 'sm', className }: SpinnerProps) {
  return (
    <Loader2
      data-testid="spinner"
      data-size={size}
      className={cn('shrink-0 animate-spin', sizeClasses[size], className)}
    />
  );
}
